<template>
    <div class="home pure-g">
    
        <MainMenu class="pure-u-1-6"/>

        <div class="pure-u-5-6">
      
            <div class="menuBarBox">
                <div id="menuBar" class="pure-menu pure-menu-horizontal menuBar">
                    <li class="pure-menu-item"><router-link class="pure-menu-link" to="/stocktakings" >Abbrechen</router-link></li>
                    <li class="pure-menu-item"><a class="pure-menu-link" v-on:click="save" >Speichern</a></li>
                </div>
            </div>

            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Neue Inventur</legend>

                        <div class="pure-g">
                            <div class="pure-u-1-1">
                                <label for="store">Filiale</label>
                                <input id="store" class="pure-u-10-24" type="text" v-model="store">
                            </div>

                            <div class="pure-u-1-1">
                                <label for="modulePicker">Inventur Typ</label>
                                <select id="modulePicker" v-model="selectedModule">
                                    <option v-for="module in  modules" :key="module.name"  :value="module._links.self.href">{{ module.name }}</option>
                                </select>
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="datePicker">Datum</label>
                                <datepicker id="datePicker" format="dd.MM.yyyy" class="pure-u-10-24 comment" v-model="date">
                                </datepicker>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import Datepicker from 'vuejs-datepicker'
import axios from "axios"
import router from '@/router.js'
import { getJwt } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'
import { getApiUrl } from '@/utils/api.js'

export default {
    name: 'NewStocktakingView',
    components: {
        MainMenu,
        Datepicker
    },
    data: function() {
        return {
            date: null,
            store: null,
            modules: [],
            selectedModule: null
        }
    },
    mounted: function() {

        this.loadData()
    },
    methods: {

        loadData: function() {

            axios({
                method: "GET",
                url: getApiUrl() + "/v0/modules?type=stocktaking",
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    
                    this.modules = result.data.data
                    console.log(this.modules)
                },
                error => {
                    toastError(error.response.data.message);
                }
            )
        },

        save: function() {

            console.log(this.selectedModule)

            axios({
                method: "POST",
                url: this.selectedModule + "/stocktakings/",
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getJwt()
                },
                data: {
                    date: this.date.getTime(),
                    store: this.store
                }
            }).then(
                result => {
                toastInfo("Eine neue Inventur wurde angelegt.");

                if (doReturn) {
                    router.push({ name: "stocktakingView" });
                } else {
                    this.clear();
                }
                },
                error => {
                    toastError(error.response.data.message);
                }
            )
        }
    }
}
</script>

<style>

#date {
    background-color: white;
}

#datePicker {
    background-color: white; 
}
</style>
